import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import Invoice from "../screens/invoice/Invoice";
import Error404 from "../screens/Error404/error404";
import Error401 from "../screens/Error401/error401";
import CircularIndeterminate from "../components/CircularIndeterminate";
import Login from "../screens/loginScreen/login";
import { useSelector } from "react-redux";
import { RootState } from "../store/reducers";
import { setCookie, getCookie, erase } from "../helper/cookieFunction";
import ScanQrCode from "../screens/ScanQrCode/ScanQrCode";
import InvoiceMarkedPopup from "../components/InvoiceMarkedPopup/InvoiceMarkedPopup";

const Routing = () => {
  const {token ,invoiceMarkedpopup} = useSelector(
    (state: RootState) => state.waiter
  );
  return (
    <div className="loginBackground">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/scan-qr-code" element={<ScanQrCode />} />
          <Route path="/invoice/:id" element={<Invoice />} />
          <Route path="/unauthorized" element={<Error401 />} />
          <Route path="*" element={<Error404 />} />
        </Routes>

        {invoiceMarkedpopup && <InvoiceMarkedPopup /> } 
    </div>
  );
};

export default Routing;
